import { useGT } from 'gt-react';
import { cn } from '@/lib/utils';
import type { Designation } from './cartLineDesignation';

const designationStyles: Record<Designation, string> = {
  buy: 'bg-blue-100 text-blue-700',
  transfer: 'bg-gray-200 text-gray-600',
  buy_and_transfer: 'bg-indigo-100 text-indigo-700',
  stock: 'bg-emerald-100 text-emerald-800',
  mixed: 'bg-amber-100 text-amber-800',
};

export function DesignationBadge({
  designation,
}: {
  designation: Designation;
}) {
  const gt = useGT();
  const label = (() => {
    switch (designation) {
      case 'buy':
        return gt('Buy', { context: 'cart line designation' });
      case 'transfer':
        return gt('Transfer', { context: 'cart line designation' });
      case 'buy_and_transfer':
        return gt('Buy + Transfer', { context: 'cart line designation' });
      case 'stock':
        return gt('In stock', { context: 'cart line designation' });
      case 'mixed':
        return gt('Mixed', { context: 'cart designation rollup' });
    }
  })();

  return (
    <span
      className={cn(
        'inline-block rounded px-1.5 py-0.5 text-xs font-medium leading-none',
        designationStyles[designation],
      )}
    >
      {label}
    </span>
  );
}
